import { Helmet } from 'react-helmet-async';
import { useState, useEffect } from 'react';
import * as React from 'react';
import { Stack, Typography, Grid, Button } from '@mui/material';
import CircularProgress from '@mui/material/CircularProgress';
import Box from '@mui/material/Box';
import CardMedia from '@mui/material/CardMedia';
import Link from '@mui/material/Link';
import { getDatabase, ref as dbref, runTransaction, set, child, get, update, remove } from 'firebase/database';
import { initializeApp } from 'firebase/app';
import useMediaQuery from '@mui/material/useMediaQuery';
import { useTheme } from '@mui/material/styles';

const firebaseConfig = {
  apiKey: 'AIzaSyDLVrlBPuai36n-i4F5HQVTjSMkVeGVBak',
  authDomain: 'onetweb-e3d8e.firebaseapp.com',
  databaseURL: 'https://onetweb-e3d8e-default-rtdb.asia-southeast1.firebasedatabase.app',
  projectId: 'onetweb-e3d8e',
  storageBucket: 'onetweb-e3d8e.firebasestorage.app',
  messagingSenderId: '60910494595',
  appId: '1:60910494595:web:2dc6bf320d67371af04cb6',
  measurementId: 'G-0ZTHXZBNP9',
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const rtdb = getDatabase(app);

// ----------------------------------------------------------------------

export default function HomePage() {
  const [row, setRow] = useState([]);
  const [title, setTitle] = useState('');
  const [subtitle, setSubTitle] = useState('');
  const [description, setDescription] = useState('');
  const [bgvideo, setbgvideo] = useState(null);

  const [c1title, setc1Title] = React.useState('');
  const [c1description, setc1Description] = React.useState('');
  const [imgphoto1, setimgphoto1] = React.useState(null);

  const [c2title, setc2Title] = React.useState('');
  const [c2description, setc2Description] = React.useState('');
  const [imgphoto2, setimgphoto2] = React.useState(null);

  const [c3title, setc3Title] = React.useState('');
  const [c3description, setc3Description] = React.useState('');
  const [imgphoto3, setimgphoto3] = React.useState(null);

  const [header, setHeader] = useState('');
  const [loading, setLoading] = useState(true);

  const theme = useTheme();
  const matches = useMediaQuery(theme.breakpoints.up('md'));

  // ⭐ NEW STATES FOR VIDEO LOADING
  const [videoLoaded, setVideoLoaded] = useState(false);
  const [fadeOut, setFadeOut] = useState(false);

  

  const [firstRenderReady, setFirstRenderReady] = useState(false);

  const fullyReady = firstRenderReady && !loading && videoLoaded && fadeOut;

useEffect(() => {
  // Ensures loader covers the very first browser paint
  setTimeout(() => setFirstRenderReady(true), 50);
}, []);

  useEffect(() => {
    get(child(dbref(rtdb), `home`))
      .then((snapshot) => {
        if (snapshot.exists()) {
          setTitle(snapshot.val().title);
          setSubTitle(snapshot.val().subtitle);
          setDescription(snapshot.val().description);
          setbgvideo(snapshot.val().bg_fullPath);

          setc1Title(snapshot.val().c1title);
          setc1Description(snapshot.val().c1description);
          setimgphoto1(snapshot.val().file1_fullPath);

          setc2Title(snapshot.val().c2title);
          setc2Description(snapshot.val().c2description);
          setimgphoto2(snapshot.val().file2_fullPath);

          setc3Title(snapshot.val().c3title);
          setc3Description(snapshot.val().c3description);
          setimgphoto3(snapshot.val().file3_fullPath);
        } else {
          setTitle('');
          setSubTitle('');
          setDescription('');
          setbgvideo(null);
          setHeader('');

          setc1Title('');
          setc1Description('');
          setimgphoto1(null);

          setc2Title('');
          setc2Description('');
          setimgphoto2(null);

          setc3Title('');
          setc3Description('');
          setimgphoto3(null);
        }

        get(child(dbref(rtdb), `solution`)).then((snapshot3) => {
          if (snapshot3.exists()) {
            setHeader(snapshot3.val().header);
          } else {
            setHeader('');
          }

          const arr = [];
          get(child(dbref(rtdb), `solutions`))
            .then((snapshot2) => {
              if (snapshot2.exists()) {
                 snapshot2.forEach((doc) => {
                  arr.push({
                    ...doc.val(),
                  });
                });
                setRow(arr);
                setLoading(false);
              } else {
                setRow([]);
                setLoading(false);
              }
            })
            .catch((error) => console.error(error));
        });
      })
      .catch((error) => console.error(error));
  }, []);

 if (loading) {
  return (
    <Grid
      style={{
        width: '100%',
        height: '100vh',            // ⭐ FULL HEIGHT
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',   // ⭐ CENTER VERTICALLY & HORIZONTALLY
        backgroundColor: '#000',
      }}
    >
      <CircularProgress color="inherit" />
    </Grid>
  );
}

  return (
    <>
      <Helmet>
        <title> Home | OneT | Leading DevSecOps Service Provider</title>
      </Helmet>

      {/* ⭐ VIDEO LOADING OVERLAY WITH FADE OUT */}
      {!fullyReady && (
        <Grid
          style={{
            position: 'fixed',
            top: 0,
            left: 0,
            width: '100%',
            height: '100vh',
            backgroundColor: '#000',
            zIndex: 9999,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            opacity: fadeOut ? 0 : 1,
            transition: 'opacity 0.6s ease-in-out',
          }}
        >
          <CircularProgress color="inherit" />
        </Grid>
      )}

      <Grid
        style={{
          top: 0,
          width: '100%',
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          flexDirection: 'column',
          opacity: fullyReady ? 1 : 0,         // ⭐ ADDED
    transition: 'opacity 0.5s ease-in',  // ⭐ ADDED
        }}
      >
        {/* ⭐ DESKTOP VIDEO */}
        {matches ? (
          <Grid
  sx={{
    zIndex: 0,
    position: "absolute",
    top: 0,
    left: 0,
    width: "100%",
    minHeight: "100vh",
    height: "auto",
    overflow: "hidden",
  }}
>
  <video
    playsInline
    autoPlay
    loop
    muted
    onLoadedData={() => {
      setFadeOut(true);
      setTimeout(() => setVideoLoaded(true), 600);
    }}
    style={{
      width: "100%",
      height: "100%",
      objectFit: "cover",
    }}
  >
    <source src={bgvideo} type="video/mp4" />
  </video>
</Grid>
        ) : (
          /* ⭐ MOBILE VIDEO */
          <Grid
  sx={{
    zIndex: 0,
    position: "absolute",   // <-- FIXED → ABSOLUTE
    top: 0,
    left: 0,
    width: "100vw",
    height: "100dvh",
    overflow: "hidden",
    backgroundColor: "#1b0049",
  }}
>
  <video
  playsInline
  autoPlay
  loop
  muted
  onLoadedData={() => {
    setFadeOut(true);
    setTimeout(() => setVideoLoaded(true), 600);
  }}
  style={{
    width: "100%",
    height: "100%",
    objectFit: "cover",
  }}
>
    <source src="/assets/videobg.mp4" type="video/mp4" />
  </video>
</Grid>
        )}

        {/* CONTENT BELOW — unchanged */}
        <Grid
          style={{
            maxWidth: 1200,
            zIndex: 1,
            marginTop: 120,
            width: '100%',
            display: 'flex',
            padding: 25,
            paddingTop: 60,
            paddingBottom: 20,
            flexDirection: 'column',
            backgroundColor: 'Transparent',
          }}
        >
          <Typography style={{ fontWeight: 'bold', fontSize: 40, color: 'white', textTransform: 'uppercase' }}>
            {title}
          </Typography>
          <Typography
            style={{ marginTop: -10, fontWeight: 'lighter', fontSize: 40, color: 'white', textTransform: 'uppercase' }}
          >
            {subtitle}
          </Typography>
          <Typography sx={{ whiteSpace: 'pre-wrap' }} style={{ maxWidth: 500, fontWeight: 300, fontSize: 16, color: 'white' }}>
            {description}
          </Typography>

          <Link href="/services" style={{ textDecoration: 'none' }}>
            <Grid style={{ marginTop: 80, cursor: 'pointer' }}>
              <img src="assets/findoutbtn.png" alt="find out button" width={120} />
            </Grid>
          </Link>
        </Grid>

        <Grid
          style={{
            zIndex: 1,
            backgroundColor: '#1b0049',
            width: '100%',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            flexDirection: 'column',
          }}
        >
          <Grid
            style={{
              padding: 25,
              maxWidth: 1200,
              marginTop: 10,
              width: '100%',
              display: 'flex',
              alignItems: 'center',
              flexDirection: 'column',
              backgroundColor: 'Transparent',
            }}
          >
            <Typography
              style={{
                textAlign: 'center',
                fontWeight: 'bold',
                fontSize: 36,
                color: 'white',
                textTransform: 'uppercase',
              }}
            >
              {header}
            </Typography>
          </Grid>

          <Grid container spacing={2} style={{ padding: 25, maxWidth: 1200 }}>
            {row.map((val) => (
              <Grid item sm={6} md={4} lg={4} xs={12} style={{ cursor: 'pointer', textDecoration: 'none' }}>
                <Link href={`/solutions/${val.prefix}`} style={{ textDecoration: 'none' }}>
                  <Grid
                    style={{
                      display: 'flex',
                      flexDirection: 'column',
                      borderRadius: 30,
                      backgroundColor: '#331a5c',
                      textDecoration: 'none',
                      minHeight: matches ? 200 : 100,
                    }}
                  >
                    <Typography
                      style={{
                        textDecoration: 'none',
                        lineHeight: 1.2,
                        padding: 30,
                        fontWeight: 'bold',
                        fontSize: 18,
                        paddingBottom: 5,
                        color: 'white',
                      }}
                    >
                      {val.title}
                    </Typography>

                    <Typography
                      style={{ lineHeight: 1.2, paddingLeft: 30, paddingRight: 30, fontSize: 12, color: '#af9ad3' }}
                    >
                      {val.subtitle ? val.subtitle : ''}
                    </Typography>

                    <Grid style={{ display: 'flex', padding: 30, flexDirection: 'row' }}>
                      <Typography
                        style={{ lineHeight: 1.2, width: 80, fontWeight: 'bold', fontSize: 14, color: 'white' }}
                      >
                        Learn More
                      </Typography>
                      <img src="assets/solutions/arrowicon.png" alt="arrow icon" width={14} />
                    </Grid>
                  </Grid>
                </Link>
              </Grid>
            ))}
          </Grid>

          <Grid container spacing={2} style={{ padding: 25, maxWidth: 1200 }}>
            <Grid
              item
              sm={4}
              md={5}
              lg={5}
              xs={12}
              style={{ display: 'flex', justifyContent: 'center', alignItems: 'flex-start', flexDirection: 'column' }}
            >
              <Grid>
                <Typography
                  style={{ fontWeight: 'bold', fontSize: 24, color: 'white', textTransform: 'uppercase', width: 200 }}
                >
                  {c1title}
                </Typography>
                <Typography style={{ fontSize: 16, maxWidth: 200, color: '#af9ad3', marginTop: 20 }}>
                  {c1description}
                </Typography>

                <Grid style={{ width: 100, marginTop: 20, cursor: 'pointer' }}>
                  <Link href="/solutions" style={{ textDecoration: 'none' }}>
                    <img src="assets/home/learnmorebtn.png" alt="learnmorebtn" width="100%" />
                  </Link>
                </Grid>
              </Grid>
            </Grid>
            <Grid item sm={8} md={7} lg={7} xs={12}>
              <img src={imgphoto1} alt="img 1" width="100%" />
            </Grid>
          </Grid>

          <Grid container spacing={2} style={{ padding: 25, maxWidth: 1200 }}>
            <Grid item sm={8} md={7} lg={7} xs={12}>
              <img src={imgphoto2} alt="img 2" width="100%" />
            </Grid>

            <Grid
              item
              sm={4}
              md={5}
              lg={5}
              xs={12}
              style={{ display: 'flex', justifyContent: 'center', alignItems: 'flex-end', flexDirection: 'column' }}
            >
              <Grid>
                <Typography
                  style={{ fontWeight: 'bold', fontSize: 24, color: 'white', textTransform: 'uppercase', width: 250 }}
                >
                  {c2title}
                </Typography>
                <Typography style={{ fontSize: 16, maxWidth: 200, color: '#af9ad3', marginTop: 20 }}>
                  {c2description}
                </Typography>

                <Grid style={{ width: 100, marginTop: 20, cursor: 'pointer' }}>
                  <Link href="/services" style={{ textDecoration: 'none' }}>
                    <img src="assets/home/learnmorebtn.png" alt="learnmorebtn" width="100%" />
                  </Link>
                </Grid>
              </Grid>
            </Grid>
          </Grid>

          <Grid container spacing={2} style={{ padding: 25, maxWidth: 1200, paddingBottom: 150 }}>
            <Grid
              item
              sm={5}
              md={5}
              lg={5}
              xs={12}
              style={{ display: 'flex', justifyContent: 'center', alignItems: 'flex-start', flexDirection: 'column' }}
            >
              <Grid>
                <Typography
                  style={{ fontWeight: 'bold', fontSize: 24, color: 'white', textTransform: 'uppercase', width: 250 }}
                >
                  {c3title}
                </Typography>
                <Typography style={{ fontSize: 16, maxWidth: 200, color: '#af9ad3', marginTop: 20 }}>
                  {c3description}
                </Typography>

                <Grid style={{ width: 100, marginTop: 20, cursor: 'pointer' }}>
                  <Link href="/contactus" style={{ textDecoration: 'none' }}>
                    <img src="assets/home/learnmorebtn.png" alt="learnmorebtn" width="100%" />
                  </Link>
                </Grid>
              </Grid>
            </Grid>
            <Grid item sm={7} md={7} lg={7} xs={12}>
              <img src={imgphoto3} alt="img 1" width="100%" />
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    </>
  );
}
